export default "__VITE_ASSET__C07lDQcI__"